import {cloneDeep} from "lodash";
import {getString} from "Core/helpers/data";
import {LanguagesCodebookListItemDataObject} from "../dataObjects";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {LanguagesCodebookListItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new LanguagesCodebookListItemDataObject(
		getString(result, 'id'),
		getString(result, 'title'),
		getString(result, 'code'),
		getString(result, 'description'),
	);

	return result;
}

// @note There is no output function since list is read only.